import React from 'react';
import { ProgressBar, tokens } from '@welbe/web-design-system';

import { ContainerProgressBar, ContainerBar } from './BarInfo.styles';

export interface BarInfoProps {
	risks?: any;
	position?: number;
}

export const BarInfo = ({ risks, position }: BarInfoProps) => {
	const isTheFirstForm = position === 0;

	if (isTheFirstForm) {
		return <></>;
	}

	return (
		<ContainerProgressBar>
			{risks.map((risk: any) => {
				return (
					<ContainerBar key={risk.id}>
						<p className="percentLabel">{`${
							risk.percent || risk.percentage || 0
						}%`}</p>
						<label className="textLabel">{risk.name}</label>
						<ProgressBar
							backgroundColor={tokens.color_gray_medium}
							percentValue={risk.percent || risk.percentage || 0}
							progressColor={risk.color}
							hasLabel
							labelText={risk.total || '0'}
						/>
					</ContainerBar>
				);
			})}
		</ContainerProgressBar>
	);
};
